__turbopack_context__.v({
  "modal-trigger": "_25V6SG_modal-trigger",
  "modal-trigger__actions": "_25V6SG_modal-trigger__actions",
  "modal-trigger__actions--is-theme-secondary": "_25V6SG_modal-trigger__actions--is-theme-secondary",
  "modal-trigger__button": "_25V6SG_modal-trigger__button",
});
